import setPaymentMethod from './setPaymentMethod';

export default setPaymentMethod;
